module.exports = __webpack_public_path__ + "static/carbon-datepicker-range-aa9d36bc22733d63c4165d6039f8fbc4.png";